// src/config/index.ts
export interface Config {
  auth0: {
    domain: string;
    clientId: string;
    audience: string;
    callbackUrl: string;
    postLogoutRedirectUrl: string;
  };
  origin: {
    url: string;
  };
  backend: {
    url: string;
  };
}

const requiredEnvVars = {
  REACT_APP_AUTH0_DOMAIN: 'Auth0 Domain',
  REACT_APP_AUTH0_CLIENT_ID: 'Auth0 Client ID',
  REACT_APP_AUTH0_AUDIENCE: 'Auth0 Audience',
  REACT_APP_AUTH0_CALLBACK_URL: 'Auth0 Callback URL',
  REACT_APP_AUTH0_POST_LOGOUT_REDIRECT_URL: 'Auth0 Post Logout Redirect URL',
  REACT_APP_API_URL: 'API URL',
  REACT_APP_API_GATEWAY_URL: 'API Gateway URL',
} as const;

export const getConfig = (): { config: Config; missingEnvVars: string[] } => {
  const missingEnvVars: string[] = [];

  // Check for missing environment variables
  Object.entries(requiredEnvVars).forEach(([key]) => {
    if (!process.env[key]) {
      missingEnvVars.push(key);
    }
  });

  // If any env vars are missing, return null config
  if (missingEnvVars.length > 0) {
    return { config: {
      auth0: {
        domain: '',
        clientId: '',
        audience: '',
        callbackUrl: '',
        postLogoutRedirectUrl: '',
      },
      origin: {
        url: '',
      },
      backend: {
        url: '',
      },
    }, missingEnvVars };
  }

  // Return the config object if all env vars are present
  return {
    config: {
      auth0: {
        domain: process.env.REACT_APP_AUTH0_DOMAIN!,
        clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE!,
        callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL!,
        postLogoutRedirectUrl: process.env.REACT_APP_AUTH0_POST_LOGOUT_REDIRECT_URL!,
      },
      origin: {
        url: process.env.REACT_APP_API_URL!,
      },
      backend: {
        url: process.env.REACT_API_GATEWAY_URL!,
      },
    },
    missingEnvVars: [],
  };
};

// Optional: Export a helper function to check if the environment is properly configured
export const isConfigured = (): boolean => {
  const { config } = getConfig();
  return config !== null;
};